import { Component, Input, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { ComponentThemeType, ComponentSizeType, ComponentVariantType } from '../common/componentStyleTypes';
@Component({
  selector: 'button[cp-button], a[cp-button]',
  templateUrl: 'cp-button.component.html',
  host: {
    'role': 'button',
    'class': `cp-button`,
    '[class.cp-button--blue]': 'isBlue',
    '[class.cp-button--blue-light]': 'isBlueLight',
    '[class.cp-button--blue-alt]': 'isBlueAlt',
    '[class.cp-button--yellow]': 'isYellow',
    '[class.cp-button--small]': 'isSizeSmall',
    '[class.cp-button--regular]': 'isSizeRegular',
    '[class.cp-button--large]': 'isSizeLarge',

    '[class.cp-button--ds-blue]': 'isDsBlue',
    '[class.cp-button--ds-blue__primary]': 'isDsBlue && isPrimaryVariant',
    '[class.cp-button--ds-blue__secondary]': 'isDsBlue && isSecondaryVariant',
    '[class.cp-button--ds-blue__blue]': 'isDsBlue && isBlueVariant',
    '[class.cp-button--ds-blue__blue-alt]': 'isDsBlue && isBlueAltVariant',
  },
})
export class CpButtonComponent {
  @Input() theme: string = ComponentThemeType.BLUE;
  @Input() size: string = ComponentSizeType.REGULAR;
  @Input() variant: string = ComponentVariantType.PRIMARY;
  @Input() showIcon: boolean = false;
  @Input() cpicon = 'back_arrow';

  constructor(public el: ElementRef, public renderer: Renderer2) {}

  // Hack to fix hit-snap-svc
  // @TODO HL-39980 we should be using MouseEvent type here but this causes an error in hit-snap-svc
  @HostListener('click', ['$event ']) onClick(ev) {
    // Step 1 - Create a new div and add it to the current element that is being clicked
    const circle = document.createElement('div');
    this.el.nativeElement.appendChild(circle);

    // step 2- Get whichever is largest so the bubble extends to that point.
    const d = Math.max(this.el.nativeElement.clientWidth, this.el.nativeElement.clientHeight);

    circle.style.width = circle.style.height = d + 'px';

    const rect = this.el.nativeElement.getBoundingClientRect();

    //  Step 3 - psotion the newly created circle in the center of where the user clicks
    circle.style.left = ev.clientX - rect.left - d / 2 + 'px';
    circle.style.top = ev.clientY - rect.top - d / 2 + 'px';

    // step 4 - applies the correct ripple class based on the theme
    if (
      this.theme === ComponentThemeType.BLUE ||
      this.theme === ComponentThemeType.YELLOW ||
      this.theme === ComponentThemeType.DS_BLUE
    ) {
      circle.classList.add('ripple');
    } else if (this.theme === ComponentThemeType.BLUE_ALT || this.theme === ComponentThemeType.BLUE_LIGHT) {
      circle.classList.add('ripple-alt');
    }
  }

  get isBlue(): boolean {
    return this.theme === ComponentThemeType.BLUE;
  }

  get isDsBlue(): boolean {
    return this.theme === ComponentThemeType.DS_BLUE;
  }

  get isBlueLight(): boolean {
    return this.theme === ComponentThemeType.BLUE_LIGHT;
  }

  get isBlueAlt(): boolean {
    return this.theme === ComponentThemeType.BLUE_ALT;
  }

  get isYellow(): boolean {
    return this.theme === ComponentThemeType.YELLOW;
  }

  get isSizeSmall(): boolean {
    return this.size === ComponentSizeType.SMALL;
  }

  get isSizeRegular(): boolean {
    return this.size === ComponentSizeType.REGULAR;
  }

  get isSizeLarge(): boolean {
    return this.size === ComponentSizeType.LARGE;
  }

  get isPrimaryVariant(): boolean {
    return this.variant === ComponentVariantType.PRIMARY;
  }

  get isSecondaryVariant(): boolean {
    return this.variant === ComponentVariantType.SECONDARY;
  }

  get isBlueVariant(): boolean {
    return this.variant === ComponentVariantType.BLUE;
  }

  get isBlueAltVariant(): boolean {
    return this.variant === ComponentVariantType.BLUE_ALT;
  }
}
